"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbDateTime = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _uuid = require("uuid");

var _shapes = require("../../skybase-core/shapes");

var _value2 = require("../../skybase-core/utils/value");

var _isTriggeredInside = require("../../skybase-core/utils/is-triggered-inside");

var _sbDate = require("./sb-date");

var _sbTime = require("./sb-time");

var _sbTextbox = require("../sb-textbox");

var _constants = require("./constants");

var _utils = require("./utils");

var _sbLocale = require("../sb-locale");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TOP_LEFT = _constants.positions.TOP_LEFT,
    TOP_RIGHT = _constants.positions.TOP_RIGHT,
    BOTTOM_LEFT = _constants.positions.BOTTOM_LEFT,
    BOTTOM_RIGHT = _constants.positions.BOTTOM_RIGHT;
var DATE = _constants.types.DATE,
    TIME = _constants.types.TIME,
    DATETIME = _constants.types.DATETIME;

var NOOP = function NOOP() {};

var NEW_DATE = new Date();

var _SbDateTime = /*#__PURE__*/function (_PureComponent) {
  _inherits(_SbDateTime, _PureComponent);

  var _super = _createSuper(_SbDateTime);

  function _SbDateTime(props) {
    var _this;

    _classCallCheck(this, _SbDateTime);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "formatInput", function (value) {
      var _this$props = _this.props,
          locale = _this$props.locale,
          type = _this$props.type,
          format = _this$props.format,
          _this$props$sbLocale = _this$props.sbLocale,
          getLocaleFormat = _this$props$sbLocale.getLocaleFormat,
          formatOutput = _this$props$sbLocale.format;
      var localeFormat = getLocaleFormat(locale);

      if (type === DATE) {
        return formatOutput({
          value: value,
          format: (0, _utils.isEmptyObject)(format) ? localeFormat.dateFormat : format
        });
      }

      if (type === TIME) {
        return formatOutput({
          value: value,
          format: (0, _utils.isEmptyObject)(format) ? localeFormat.timeFormat : format
        });
      }

      return formatOutput({
        value: value,
        format: (0, _utils.isEmptyObject)(format) ? "".concat(localeFormat.dateFormat, " ").concat(localeFormat.timeFormat) : format
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnActiveDateChange", function (value) {
      _this.setState({
        activeDate: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnPickerChange", function (_ref) {
      var date = _ref.date,
          dateRaw = _ref.dateRaw,
          inputValue = _ref.inputValue;
      var _this$props2 = _this.props,
          onChange = _this$props2.onChange,
          closeOnSelect = _this$props2.closeOnSelect,
          open = _this$props2.open;
      var type = _this.state.type;

      _this.setState(function (prevState) {
        var willBeOpened = prevState.isOpened ? !(type === DATE && closeOnSelect) : false;

        if (!(0, _value2.isNullOrUndefined)(open)) {
          willBeOpened = open;
        }

        return {
          displayedText: inputValue || _this.formatInput(date),
          isOpened: willBeOpened
        };
      });

      onChange({
        value: date,
        valueISO: dateRaw || date.toISOString(),
        inputValue: inputValue,
        textValue: _this.formatInput(date)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnInputChange", function (event) {
      var _this$props3 = _this.props,
          readOnly = _this$props3.readOnly,
          format = _this$props3.format,
          onError = _this$props3.onError,
          onChange = _this$props3.onChange,
          _this$props3$sbLocale = _this$props3.sbLocale,
          validateDate = _this$props3$sbLocale.validateDate,
          validateTime = _this$props3$sbLocale.validateTime,
          validateDateTime = _this$props3$sbLocale.validateDateTime;
      var type = _this.state.type;

      if (!readOnly) {
        var inputValue = event.target.value && event.target.value ? event.target.value : '';
        var rawValue = event && event.target ? event.target.value : inputValue;

        if (!rawValue || !rawValue.length) {
          _this.setState({
            displayedText: ''
          });

          onChange({
            value: null,
            valueISO: null,
            inputValue: rawValue,
            textValue: null
          });
          return;
        }

        var validation = true;

        if (type === DATE) {
          validation = validateDate(rawValue, {
            format: format
          });
        }

        if (type === TIME) {
          validation = validateTime(rawValue, {
            format: format
          });
        }

        if (type === DATETIME) {
          validation = validateDateTime(rawValue, {
            format: format
          });
        }

        if (!validation.isValid) {
          _this.setState({
            displayedText: rawValue
          });

          if (onError) {
            onError(rawValue);
          }
        } else {
          _this.handleOnPickerChange({
            date: validation.date,
            dateRaw: validation.dateRaw,
            inputValue: rawValue
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnClose", function () {
      var onClose = _this.props.onClose;
      onClose();
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnOpen", function () {
      var _this$props4 = _this.props,
          onOpen = _this$props4.onOpen,
          open = _this$props4.open,
          onIconClick = _this$props4.onIconClick;

      _this.setState({
        isOpened: (0, _value2.isNullOrUndefined)(open) || open
      });

      onOpen();
      onIconClick();
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnFocus", function () {
      var _this$props5 = _this.props,
          onFocus = _this$props5.onFocus,
          value = _this$props5.value,
          openOnFocus = _this$props5.openOnFocus,
          inputOnly = _this$props5.inputOnly;

      if (!inputOnly && openOnFocus) {
        _this.handleOnOpen();
      }

      _this.setState({
        isInputFocused: true,
        displayedText: _this.formatInput(value)
      });

      if (onFocus) {
        onFocus();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnBlur", function () {
      var onBlur = _this.props.onBlur;

      _this.setState({
        isInputFocused: false
      });

      if (onBlur) {
        onBlur();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickOutside", function (event) {
      var isOpened = _this.state.isOpened;
      var open = _this.props.open;

      if (!(0, _value2.isNullOrUndefined)(open)) {
        return;
      }

      if (event && (0, _isTriggeredInside.isTriggeredInside)(_this.datePicker, event) || event && (0, _isTriggeredInside.isTriggeredInside)(_this.timePicker, event) || event && (0, _isTriggeredInside.isTriggeredInside)(_this.input, event) || event && (0, _isTriggeredInside.isTriggeredInside)(_this.inputIcon, event)) {
        // onClick->stopPropagation keeps the selection of a date in the absolute date popup from causing onClickModalOverlay to fire.
        event.stopPropagation();
        return;
      }

      if (isOpened) {
        _this.setState({
          isOpened: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderType", function () {
      var _this$props6 = _this.props,
          inputOnly = _this$props6.inputOnly,
          position = _this$props6.position,
          open = _this$props6.open;
      var _this$state = _this.state,
          type = _this$state.type,
          isOpened = _this$state.isOpened;
      var isBottom = position === BOTTOM_LEFT || position === BOTTOM_RIGHT;
      var isTop = position === TOP_LEFT || position === TOP_RIGHT;
      var opened = (0, _value2.isNullOrUndefined)(open) ? isOpened : open;

      switch (type) {
        case DATE:
          return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, isBottom && _this.renderInput(), opened ? /*#__PURE__*/_react.default.createElement("div", {
            id: _this.pickerID,
            className: "picker ".concat(position),
            role: "grid"
          }, !inputOnly && _this.renderDatePicker()) : null, isTop && _this.renderInput());

        case TIME:
          return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, isBottom && _this.renderInput(), opened ? /*#__PURE__*/_react.default.createElement("div", {
            id: _this.pickerID,
            className: "picker ".concat(position),
            role: "grid"
          }, !inputOnly && _this.renderTimePicker()) : null, isTop && _this.renderInput());

        case DATETIME:
          return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, isBottom && _this.renderInput(), opened ? /*#__PURE__*/_react.default.createElement("div", {
            id: _this.pickerID,
            className: "picker ".concat(position),
            role: "grid"
          }, !inputOnly && _this.renderDateTimePicker()) : null, isTop && _this.renderInput());

        default:
          return null;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "commonProps", function () {
      var _this$props7 = _this.props,
          open = _this$props7.open,
          position = _this$props7.position,
          locale = _this$props7.locale;
      var isOpened = _this.state.isOpened;
      var opened = (0, _value2.isNullOrUndefined)(open) ? isOpened : open;
      return {
        onChange: _this.handleOnPickerChange,
        onClose: _this.handleOnClose,
        onOpen: _this.handleOnOpen,
        onFocus: _this.handleOnFocus,
        onControlChange: _this.handleOnActiveDateChange,
        open: opened,
        locale: locale,
        position: position
      };
    });

    _defineProperty(_assertThisInitialized(_this), "renderInput", function () {
      var _this$props8 = _this.props,
          _inputRef = _this$props8.inputRef,
          inputOnly = _this$props8.inputOnly,
          position = _this$props8.position,
          value = _this$props8.value,
          locale = _this$props8.locale,
          hasError = _this$props8.hasError,
          _this$props8$sbLocale = _this$props8.sbLocale,
          getMessages = _this$props8$sbLocale.getMessages,
          getLocaleFormat = _this$props8$sbLocale.getLocaleFormat,
          disabled = _this$props8.disabled,
          inputProps = _this$props8.inputProps,
          onIconClick = _this$props8.onIconClick;
      var _this$state2 = _this.state,
          displayedText = _this$state2.displayedText,
          type = _this$state2.type,
          isInputFocused = _this$state2.isInputFocused;
      var inputValue = '';

      if (isInputFocused) {
        inputValue = displayedText;
      } else {
        inputValue = value ? _this.formatInput(value) : '';
      }

      var iconClass = type === DATE ? 'sbi-date' : 'sbi-time';
      var iconOnClickHandler = !inputOnly && !disabled ? _this.handleOnOpen : onIconClick;
      var spanClassName = !inputOnly ? 'date-icon' : 'date-icon input-only';
      var placeholder = type === DATE ? getMessages().datePlaceholder : getMessages().timePlaceholder;

      if (type === DATETIME) {
        placeholder = getMessages().dateTimePlaceholder;
        iconClass = 'sbi-datetime';
      }

      if (inputOnly) {
        var _getLocaleFormat = getLocaleFormat(locale),
            dateFormat = _getLocaleFormat.dateFormat,
            timeFormat = _getLocaleFormat.timeFormat;

        placeholder = type === DATE ? dateFormat : timeFormat;

        if (type === DATETIME) {
          placeholder = "".concat(dateFormat, " ").concat(timeFormat);
        }
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)('input-div', position, {
          disabled: disabled
        })
      }, /*#__PURE__*/_react.default.createElement(_sbTextbox.SbTextbox, _extends({}, inputProps !== null && inputProps !== void 0 ? inputProps : {}, {
        value: inputValue || '',
        inputRef: function inputRef(node) {
          _inputRef(node);

          _this.input = node;
        },
        onBlur: _this.handleOnBlur,
        onFocus: _this.handleOnFocus,
        onChange: _this.handleOnInputChange,
        addonRight: /*#__PURE__*/_react.default.createElement("span", {
          className: spanClassName
        }, /*#__PURE__*/_react.default.createElement("i", {
          className: iconClass,
          onClick: iconOnClickHandler,
          ref: function ref(node) {
            _this.inputIcon = node;
          }
        })),
        placeholder: !value ? placeholder : null,
        hasError: hasError,
        disabled: disabled
      })));
    });

    _defineProperty(_assertThisInitialized(_this), "renderDatePicker", function () {
      var _this$props9 = _this.props,
          value = _this$props9.value,
          locale = _this$props9.locale,
          _this$props9$sbLocale = _this$props9.sbLocale,
          getWeekDays = _this$props9$sbLocale.getWeekDays,
          getMonths = _this$props9$sbLocale.getMonths,
          getLocaleFormat = _this$props9$sbLocale.getLocaleFormat,
          _this$props9$format = _this$props9.format,
          year = _this$props9$format.year,
          month = _this$props9$format.month,
          day = _this$props9$format.day;
      var activeDate = _this.state.activeDate;

      var _getLocaleFormat2 = getLocaleFormat(locale),
          startingWeekday = _getLocaleFormat2.startingWeekday;

      return /*#__PURE__*/_react.default.createElement(_sbDate.SbDate, _extends({}, _this.commonProps(), {
        selectedDate: value || NEW_DATE,
        activeDate: activeDate,
        dateRef: function dateRef(node) {
          _this.datePicker = node;
        },
        format: {
          year: year,
          month: month,
          day: day
        },
        weekDays: getWeekDays('short'),
        startingWeekday: startingWeekday,
        months: getMonths()
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "renderTimePicker", function (isDateTime) {
      var _this$props10 = _this.props,
          format = _this$props10.format,
          value = _this$props10.value,
          locale = _this$props10.locale,
          getLocaleFormat = _this$props10.sbLocale.getLocaleFormat;
      return /*#__PURE__*/_react.default.createElement(_sbTime.SbTime, _extends({}, _this.commonProps(), {
        format: (0, _utils.isEmptyObject)(format) ? _constants.DEFAULT_TIME_FORMAT : format,
        localeFormat: getLocaleFormat(locale),
        timeRef: function timeRef(node) {
          _this.timePicker = node;
        },
        value: value || NEW_DATE,
        className: (0, _classnames.default)({
          'with-date': isDateTime
        })
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "renderDateTimePicker", function () {
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, _this.renderDatePicker(), _this.renderTimePicker(true));
    });

    var _value = props.value,
        _format = props.format,
        _type = props.type;
    _this.state = {
      isOpened: false,
      displayedText: _value ? _this.formatInput(_value) : '',
      activeDate: null,
      type: (0, _utils.getType)(_format, _type),
      isInputFocused: false
    };
    _this.datePicker = null;
    _this.timePicker = null;
    _this.input = null;
    _this.inputIcon = null;
    _this.pickerID = (0, _uuid.v4)();
    return _this;
  }

  _createClass(_SbDateTime, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('click', this.handleClickOutside);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('click', this.handleClickOutside);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props11 = this.props,
          className = _this$props11.className,
          style = _this$props11.style,
          open = _this$props11.open,
          disabled = _this$props11.disabled,
          ariaLabelledBy = _this$props11['aria-labelledby'];
      var isOpened = this.state.isOpened;
      var opened = (0, _value2.isNullOrUndefined)(open) ? isOpened : open;
      var zIndexStyle = opened ? {
        zIndex: 1
      } : {}; // onClick->stopPropagation keeps the selection of a date in the absolute date popup from causing onClickModalOverlay to fire.

      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)('sb-date-time', className),
        style: _objectSpread(_objectSpread({}, zIndexStyle), style),
        role: "combobox",
        tabIndex: disabled ? -1 : 0,
        "aria-labelledby": ariaLabelledBy,
        "aria-expanded": opened,
        "aria-haspopup": "grid",
        "aria-controls": this.pickerID
      }, this.renderType());
    }
  }]);

  return _SbDateTime;
}(_react.PureComponent);

_defineProperty(_SbDateTime, "propTypes", {
  position: _propTypes.default.oneOf([TOP_LEFT, TOP_RIGHT, BOTTOM_LEFT, BOTTOM_RIGHT]),
  type: _propTypes.default.oneOf([DATE, TIME, DATETIME]),
  format: _propTypes.default.object,
  // eslint-disable-line react/forbid-prop-types
  value: _propTypes.default.instanceOf(Date),
  inputRef: _shapes.PropTypeRef,
  inputOnly: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  onOpen: _propTypes.default.func,
  onClose: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  onError: _propTypes.default.func,
  onIconClick: _propTypes.default.func,
  open: _propTypes.default.bool,
  readOnly: _propTypes.default.bool,
  closeOnSelect: _propTypes.default.bool,
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  // eslint-disable-line react/forbid-prop-types
  sbLocale: _sbLocale.sbLocaleShape.isRequired,
  locale: _propTypes.default.string,
  hasError: _propTypes.default.bool,
  openOnFocus: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  inputProps: _propTypes.default.object // eslint-disable-line react/forbid-prop-types

});

_defineProperty(_SbDateTime, "defaultProps", {
  position: BOTTOM_LEFT,
  format: _constants.DEFAULT_FORMAT,
  value: null,
  inputRef: NOOP,
  type: null,
  inputOnly: false,
  onChange: NOOP,
  onOpen: NOOP,
  onClose: NOOP,
  onFocus: NOOP,
  onBlur: NOOP,
  onError: NOOP,
  onIconClick: NOOP,
  open: null,
  className: null,
  style: null,
  closeOnSelect: true,
  readOnly: false,
  locale: null,
  hasError: false,
  openOnFocus: true,
  disabled: false,
  inputProps: null
});

var SbDateTime = (0, _sbLocale.injectSbLocale)(_SbDateTime, {});
exports.SbDateTime = SbDateTime;
//# sourceMappingURL=sb-date-time.js.map